export class UserActivation {
    private hasBeenActiveByEvent = false;
    private readonly hasBeenActiveByEventListener: () => void;

    constructor() {
        this.hasBeenActiveByEventListener = this.onInteractedThroughEvent.bind(this);
        document.addEventListener("pointerdown", this.hasBeenActiveByEventListener, { passive: true });
        document.addEventListener("keydown", this.hasBeenActiveByEventListener, { passive: true });
        document.addEventListener("wheel", this.hasBeenActiveByEventListener, { passive: true });
        document.addEventListener("touchstart", this.hasBeenActiveByEventListener, { passive: true });
    }

    private onInteractedThroughEvent(): void {
        this.hasBeenActiveByEvent = true;
        document.removeEventListener("pointerdown", this.hasBeenActiveByEventListener);
        document.removeEventListener("keydown", this.hasBeenActiveByEventListener);
        document.removeEventListener("wheel", this.hasBeenActiveByEventListener);
        document.removeEventListener("touchstart", this.hasBeenActiveByEventListener);
    }

    public hasBeenActive(): boolean {
        return this.hasBeenActiveByEvent || navigator.userActivation?.hasBeenActive;
    }
}
